import { atom } from "jotai";

export const highlightJiffyDesignServiceAtom = atom(false);
